import { useState } from "react";
import { WebHook } from "../webhooks.types";
import { usePermissions } from "@/hooks/usePermissions";
import LoggingAPI from "@/api/logging";
import { Button, Modal } from "@monolith-forensics/monolith-ui";
import ButtonMenu from "@/components/Forms/components/ButtonMenu";
import { useDeleteWebhook } from "../webhooks.query";

export const DeleteWebhookModal: React.FC<{
  show: boolean;
  onClose?: () => void;
  onSubmit?: (data: WebHook) => void;
  onCancel?: () => void;
  defaultFormData: WebHook;
  buttonProps?: {
    submitText?: string;
    cancelText?: string;
  };
}> = ({
  show,
  onClose,
  onSubmit,
  onCancel,
  buttonProps = {},
  defaultFormData,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const { currentUser } = usePermissions();

  const mutation = useDeleteWebhook();
  const { mutate: deleteWebhook } = mutation;

  const handleSubmit = async () => {
    setSubmitting(true);
    deleteWebhook(defaultFormData.uuid);
    onSubmit?.(defaultFormData);
    setSubmitting(false);

    await LoggingAPI.createLog({
      case_id: undefined,
      user_id: currentUser.user_id,
      message: `Deleted webhook: ${defaultFormData.name}`,
      event: "webhook:delete",
      object_type: "webhook",
      object_uuid: defaultFormData.uuid,
    });
  };

  const handleCancel = () => {
    onCancel?.();
  };

  return (
    <Modal open={show} onClose={onClose}>
      <Modal.Title>Delete Webhook</Modal.Title>
      <div style={{ fontWeight: 600, margin: "20px 0px" }}>
        Are you sure you want to delete this webhook{" "}
        <span style={{ fontWeight: 600 }}>"{defaultFormData?.name}"</span>?
      </div>
      <ButtonMenu>
        <Button
          size="xs"
          variant="subtle"
          onClick={handleCancel}
          disabled={submitting}
        >
          {buttonProps?.cancelText || "Cancel"}
        </Button>
        <Button
          size="xs"
          color="error"
          variant="contained"
          onClick={handleSubmit}
          disabled={submitting}
          loading={submitting}
        >
          {buttonProps?.submitText || "Delete Webhook"}
        </Button>
      </ButtonMenu>
    </Modal>
  );
};
